import React, { HTMLProps } from 'react'
import { styled } from '@mui/material/styles'

import { Typography } from '@mui/material'

import SidebarNavList from './SidebarNavList'
import { SidebarNavProps } from './SidebarNav'

const Title = styled(Typography)`
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.caption.fontSize};
    padding: ${(props) => props.theme.spacing(4)} ${(props) => props.theme.spacing(7)}
        ${(props) => props.theme.spacing(1)};
    opacity: 0.4;
    text-transform: uppercase;
    display: block;
`

interface SidebarNavSectionProps extends HTMLProps<'div'> {
    title: string
    pages: SidebarNavProps['items'][number]['pages']
    component: string
}

const SidebarNavSection = (props: SidebarNavSectionProps) => {
    const { title, pages, component: Component = 'nav', ...rest } = props

    return (
        <Component {...rest}>
            {title && <Title variant='subtitle2'>{title}</Title>}
            <div></div>
            <SidebarNavList pages={pages} depth={0} />
        </Component>
    )
}

export default SidebarNavSection
